import {getQuery} from "../../common/utils";

const get = (business_id, type) => {
  const params = {
    business_id,
    type,
  };
  return getQuery('custom_filters', params);
};

export const filterService = {
  get
};
